var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconB-question",
    x: 0,
    y: 0,
    width: 23.998,
    height: 23.998,
    style: {
      fill: "none"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconB-question1",
    serifid: "iconB-question"
  }, /*#__PURE__*/React.createElement("path", {
    id: "question-mark",
    serifid: "question mark",
    d: "M14.427,1.989c2.847,-0 5.163,2.315 5.163,5.161c-0,1.861 -1.009,3.585 -2.631,4.499l-4.45,2.503c-0.143,0.081 -0.232,0.232 -0.232,0.396l0.003,1.452c0,0.558 -0.451,1.003 -1.009,1.003c-0.557,-0 -1.008,-0.451 -1.008,-1.009l-0.004,-1.446c0,-0.89 0.483,-1.716 1.26,-2.153l4.45,-2.504c0.989,-0.557 1.603,-1.607 1.603,-2.741c-0,-1.733 -1.411,-3.144 -3.145,-3.144l-4.866,0c-1.728,0 -3.135,1.406 -3.135,3.135l0,0.976c0,0.557 -0.451,1.008 -1.008,1.008c-0.558,0 -1.009,-0.451 -1.009,-1.008l-0,-0.976c-0,-2.841 2.311,-5.152 5.152,-5.152l4.866,-0Zm-3.145,17.011c0.828,0 1.5,0.672 1.5,1.5c-0,0.828 -0.672,1.5 -1.5,1.5c-0.828,-0 -1.5,-0.672 -1.5,-1.5c-0,-0.828 0.672,-1.5 1.5,-1.5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBQuestion);
export default __webpack_public_path__ + "static/media/iconB-question.e2294fabc67f003e199b5c649a0e7745.svg";
export { ForwardRef as ReactComponent };